import React from 'react'

import CreateMedicalRecord from 'presentation/doctor/pages/AddSurgicalOrder/CreateMedicalRecord'
import { ApiClientImplementation } from 'infra/api-client/api-client'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { ApiRepository } from 'repository/api-repository'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'
import { RemoteUpdateSurgicalOrder } from 'service/usecases/update-surgical-order/remote-update-surgical-order'
import { PatientRepository } from 'repository/repositories/patient/patient-repository'
import { RemotePatientUpdateInfo } from 'service/usecases/patient-update-info/remote-patient-update-info'

export default function makeDoctorCreateMedicalRecord() {
  const apiClient = new ApiClientImplementation()
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(apiClient)
  )

  const surgicalOrderRepository = new SurgicalOrderRepository(apiRepository)
  const patientRepository = new PatientRepository(apiRepository)

  const updateSurgicalOrder = new RemoteUpdateSurgicalOrder(
    surgicalOrderRepository
  )
  const updatePatientInfo = new RemotePatientUpdateInfo(patientRepository)

  return (
    <CreateMedicalRecord
      updateSurgicalOrder={updateSurgicalOrder}
      updatePatientInfo={updatePatientInfo}
    />
  )
}
